import { h } from 'preact'
import { PureComponent } from 'preact-compat'
import Modal, {
  ModalHeader,
  ModalBody,
  ModalFooter
} from '../../design-system-components/modal/index'
import Button from '../../../control-components/ui-components/Button'
import Phrase from '../../../libs/translationsUtils/phrase'
import { t } from '../../../libs/translationsUtils/translations'
import { ButtonGroup } from '../../design-system-components/button'
import Form from '../../design-system-components/form'
import InputUnit from '../../design-system-components/input-unit'
import TextArea from '../../design-system-components/text-area'

interface Props {
  senderUsername: string
  reportedMessage: string
  reason: string
  onReasonChanged: (reason: string) => void
  onReport: () => void
  onCancel: () => void
  errorMessage?: string
}

class ReportPrivateMessageModal extends PureComponent<Props> {
  render() {
    const {
      senderUsername,
      reportedMessage,
      reason,
      onReasonChanged,
      onReport,
      onCancel,
      errorMessage
    } = this.props
    return (
      <Modal onClose={onCancel}>
        <ModalHeader title={<Phrase p='privateMessages.reportModal.title' />} />
        <ModalBody>
          <Form>
            <p>
              <Phrase p='privateMessages.reportModal.text' />
            </p>
            <InputUnit label={t('Forum', 'privateMessages.reportModal.sender')}>
              <span>{senderUsername}</span>
            </InputUnit>
            <InputUnit label={t('Forum', 'privateMessages.reportModal.message')}>
              <div dangerouslySetInnerHTML={{ __html: reportedMessage }} />
            </InputUnit>
            <InputUnit
              label={t('Forum', 'privateMessages.reportModal.reasons')}
              error={errorMessage}
            >
              <TextArea
                adjustHeight
                maxLength={1500}
                onContentChange={onReasonChanged}
                placeholder={t('Forum', 'privateMessages.reportModal.reasons.placeholder')}
                value={reason}
                verticalResize
              />
            </InputUnit>
          </Form>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup>
            <Button className='btn--cancel' onClick={onReport}>
              <Phrase p='privateMessages.reportModal.reportButton' />
            </Button>
            <Button className='btn--secondary' onClick={onCancel}>
              <Phrase p='privateMessages.reportModal.cancelButton' />
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ReportPrivateMessageModal
